export default __webpack_public_path__ + "content/media/IcoFacebook.3f924679.svg";